import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../pages/Homepage.css";
import globe from "./Homepage/Images/globe.png";
import thunder from "./Homepage/Images/thunder.png";
import call from "./Homepage/Images/call.png";
import sat from "./Homepage/Images/sat.png";

import i from "./Homepage/Images/send.png";
import lap from "./Homepage/Images/group.png";
import appstore from "./Homepage/Images/appstore.png";
import frame from "./Homepage/Images/Frame.png";
import newbann from "./Homepage/Images/newbann.png";
import homesec_3 from "../../src/pages/Homepage/Images/homesec-3.png";




import { FaGooglePlay } from "react-icons/fa";
import { FaApple } from "react-icons/fa";

// import half from "./Homepage/Images/half.png";
import edge from "./Homepage/Images/edge.png";


import { FaChevronRight } from "react-icons/fa";

import Navbar from "../pages/Navbar";
import Footer from "../pages/Footer";

// Countdown Timer component
const CountdownTimer = ({
  initialDays = 0,
  initialHours = 0,
  initialMinutes = 1,
  initialSeconds = 0,
}) => {
  const [days, setDays] = useState(initialDays);
  const [hours, setHours] = useState(initialHours);
  const [minutes, setMinutes] = useState(initialMinutes);
  const [seconds, setSeconds] = useState(initialSeconds);

  useEffect(() => {
    const timerInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      } else if (seconds === 0 && minutes > 0) {
        setMinutes(minutes - 1);
        setSeconds(59);
      } else if (minutes === 0 && hours > 0) {
        setHours(hours - 1);
        setMinutes(59);
        setSeconds(59);
      } else if (hours === 0 && days > 0) {
        setDays(days - 1);
        setHours(23);
        setMinutes(59);
        setSeconds(59);
      } else if (days === 0 && hours === 0 && minutes === 0 && seconds === 0) {
        clearInterval(timerInterval);
      }
    }, 1000);

    // Clean up the interval when the component unmounts
    return () => clearInterval(timerInterval);
  }, [days, hours, minutes, seconds]);

  return (
    <div className="countdown-container">
      <h1 className="countdown-heading">Launching In</h1>
      <div className="timer">
        <div className="time-container">
          <span className="time">{days < 10 ? `0${days}` : days}</span>
          <span className="label">Days</span>
        </div>
        <span className="colon">:</span>
        <div className="time-container">
          <span className="time">{hours < 10 ? `0${hours}` : hours}</span>
          <span className="label">Hours</span>
        </div>
       
      </div>
    </div>
  );
};

// Homepage component
const Homepage = () => {
  return (
    <div>
        <Navbar />

      <div className="homepage-all">
        <div className="banner ">
          <div className="flex flex-wrap lg:p-[24px] md:p-[24px] p-[16px] max-w-[1380px] mx-auto xl:h-[100vh] items-center">
            <div className="lg:w-7/12 md:w-full w-full">
              <div className="banner-des ">
                <div className="">
                <h1
                    className="text-[54px] font-[700] leading-[64px] "
                    style={{
                      background: "linear-gradient(90deg, #FFF 0%, #999 77.8%)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    There is New Era
                  </h1>

                  <h2 className="text-[54px] pb-2 font-[700] leading-[64px] "
                    style={{
                      background: "linear-gradient(90deg, #FFF 0%, #999 77.8%)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}>
                    Stay ahead with Edge – Your Technology Partner
                  </h2>
                  </div>

                <p>
                  Unlock your potential with our innovative digital solutions and resources. Whether <br /> you're streamlining operations, scaling your business, or exploring new technologies, we are with you every step of the way. <br /> Start your journey towards digital transformation today!
                </p>
                <button type="button flex gap-x-2 ">
                <a href="https://dashboard.edgepay.in/login" target="_blank" rel="noopener noreferrer">

                  Get Started
                  </a>
                   <FaChevronRight />
                </button>
              </div>
            </div>
            <div className="lg:w-5/12 md:w-full w-full">
            <img src={newbann} alt="Edge" className="md:w-full w-[100%]" style={{ overflow: "visible" }} />
            </div>
          </div>
        </div>
        {/* <div className="launching-sec">
          <CountdownTimer
            initialDays={10}
            initialHours={1}
            initialMinutes={30}
            initialSeconds={45}
          />
        </div> */}
        <div className="white-line">

       
        <div className="timer-des md:py-[60px] py-[20px]">
          <div className="flex flex-wrap justify-between max-w-[1380px] mx-auto lg:px-[24px] md:px-[24px] px-[16px]">
            <div className="md:w-1/2 w-full">
              <p>
                ARE YOU STILL CONFUSED <br />
                ABOUT YOUR DIGITAL STRATEGY? EDGE IS HERE <br />
                FOR YOU
              </p>
            </div>
            <div className="md:w-1/2 w-full flex md:justify-end justify-start">
              <h2 className="font-['Open_Sans'] text-[40px] leading-[50px] font-bold opacity-90 bg-gradient-to-br from-[#1A1A1A] to-[#808080] bg-clip-text text-transparent">
                Edge is Here To Help You <br />
                With Technology Solutions.  <br />
                We Are There For You!
              </h2>
            </div>
          </div>
        </div>



        
        <div className="iphone md:py-10 relative">
          <div className="flex flex-wrap max-w-[1380px] lg:p-[24px] md:p-[24px] p-[16px] mx-auto items-end">
            <div className="lg:w-3/12 md:w-full w-full ">
              <img src={i} alt="Edge" className="md:w-[800px] w-auto" />
            </div>
            <div className="lg:w-9/12 md:w-full w-full ms-auto">
            <div className="">
              <div className="iphone-des">
                <p className="ml-4 mb-2" >
                  <span>Edge Helps </span> The Problem You Are Facing
                </p>
                <div className="space-y-[16px]">
                  <div className="flex md:items-center items-start justify-between md:gap-x-[30px] gap-x-[20px] bg-white p-3 shadow-md rounded-[12px]">
                    <div className="">
                      <p className="md:text-[36px] text-[26px] font-semibold">1</p>
                    </div>
                    <div className="sapce-y-[12px] ">
                      <p className="text-[#1A1A1A] pb-0 font-bold md:text-[22px] text-[18px]">💡 No Hidden Fees for Our Digital Solutions</p>
                      <p className="text-[#000000]/60 md:text-[18px] text-[14px] mb-0 ">
                        Get more value, you will not be charged hidden fees for
                        the services you use. Transparent pricing for everyone.
                      </p>
                    </div>
                    <div className="">
                      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                        <path d="M13.0003 21.6666C15.2989 21.6666 17.5033 20.7535 19.1286 19.1282C20.7539 17.5029 21.667 15.2985 21.667 13C21.667 10.7014 20.7539 8.49702 19.1286 6.8717C17.5033 5.24639 15.2989 4.33329 13.0003 4.33329C10.7018 4.33329 8.49738 5.24639 6.87207 6.8717C5.24675 8.49702 4.33366 10.7014 4.33366 13C4.33366 15.2985 5.24675 17.5029 6.87207 19.1282C8.49738 20.7535 10.7018 21.6666 13.0003 21.6666ZM13.0003 23.8333C7.01708 23.8333 2.16699 18.9832 2.16699 13C2.16699 7.01671 7.01708 2.16663 13.0003 2.16663C18.9836 2.16663 23.8337 7.01671 23.8337 13C23.8337 18.9832 18.9836 23.8333 13.0003 23.8333ZM11.917 11.9166V18.4166H14.0837V11.9166H11.917ZM11.917 7.58329H14.0837V9.74996H11.917V7.58329Z" fill="black"/>
                      </svg>

                    </div>
                  </div>
                  <div className="flex md:items-center items-start justify-between md:gap-x-[30px] gap-x-[20px] bg-white p-3 shadow-md rounded-[12px]">
                    <div className="">
                      <p className="md:text-[36px] text-[26px] font-semibold">2</p>
                    </div>
                    <div className="sapce-y-[12px]">
                      <p className="text-[#1A1A1A] pb-0 font-bold md:text-[22px] text-[18px]">🔒 Secure and Seamless Digital Experiences</p>
                      <p className="text-[#000000]/60 text-[18px] mb-0">
                        We use the latest technology and always maintain the
                        security of your data and digital operations.
                      </p>
                    </div>
                    <div className="">
                      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                        <path d="M13.0003 21.6666C15.2989 21.6666 17.5033 20.7535 19.1286 19.1282C20.7539 17.5029 21.667 15.2985 21.667 13C21.667 10.7014 20.7539 8.49702 19.1286 6.8717C17.5033 5.24639 15.2989 4.33329 13.0003 4.33329C10.7018 4.33329 8.49738 5.24639 6.87207 6.8717C5.24675 8.49702 4.33366 10.7014 4.33366 13C4.33366 15.2985 5.24675 17.5029 6.87207 19.1282C8.49738 20.7535 10.7018 21.6666 13.0003 21.6666ZM13.0003 23.8333C7.01708 23.8333 2.16699 18.9832 2.16699 13C2.16699 7.01671 7.01708 2.16663 13.0003 2.16663C18.9836 2.16663 23.8337 7.01671 23.8337 13C23.8337 18.9832 18.9836 23.8333 13.0003 23.8333ZM11.917 11.9166V18.4166H14.0837V11.9166H11.917ZM11.917 7.58329H14.0837V9.74996H11.917V7.58329Z" fill="black"/>
                      </svg>

                    </div>
                  </div>
                  <div className="flex md:items-center items-start justify-between md:gap-x-[30px] gap-x-[20px] bg-white p-3 shadow-md rounded-[12px]">
                    <div className="">
                      <p className="md:text-[36px] text-[26px] font-semibold">3</p>
                    </div>
                    <div className="sapce-y-[12px]">
                      <p className="text-[#1A1A1A] pb-0 font-bold md:text-[22px] text-[18px]">🌐 Solutions for Individuals and Enterprises</p>
                      <p className="text-[#000000]/60 text-[18px] mb-0">
                        Whether you are an individual or a business, Edge provides
                        tailored solutions to help you succeed.
                      </p>
                    </div>
                    <div className="">
                      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                        <path d="M13.0003 21.6666C15.2989 21.6666 17.5033 20.7535 19.1286 19.1282C20.7539 17.5029 21.667 15.2985 21.667 13C21.667 10.7014 20.7539 8.49702 19.1286 6.8717C17.5033 5.24639 15.2989 4.33329 13.0003 4.33329C10.7018 4.33329 8.49738 5.24639 6.87207 6.8717C5.24675 8.49702 4.33366 10.7014 4.33366 13C4.33366 15.2985 5.24675 17.5029 6.87207 19.1282C8.49738 20.7535 10.7018 21.6666 13.0003 21.6666ZM13.0003 23.8333C7.01708 23.8333 2.16699 18.9832 2.16699 13C2.16699 7.01671 7.01708 2.16663 13.0003 2.16663C18.9836 2.16663 23.8337 7.01671 23.8337 13C23.8337 18.9832 18.9836 23.8333 13.0003 23.8333ZM11.917 11.9166V18.4166H14.0837V11.9166H11.917ZM11.917 7.58329H14.0837V9.74996H11.917V7.58329Z" fill="black"/>
                      </svg>

                    </div>
                  </div>
                  <div className="flex md:items-center items-start justify-between md:gap-x-[30px] gap-x-[20px] bg-white p-3 shadow-md rounded-[12px]">
                    <div className="">
                      <p className="md:text-[36px] text-[26px] font-semibold">4</p>
                    </div>
                    <div className="sapce-y-[12px]">
                      <p className="text-[#1A1A1A] pb-0 font-bold md:text-[22px] text-[18px]">🚀 Project Delivery: Fast, Reliable, and Secure</p>
                      <p className="text-[#000000]/60 text-[18px] mb-0">
                      We ensure your projects are delivered efficiently and securely, leveraging automation and best practices in technology.
                      </p>
                    </div>
                    <div className="">
                      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                        <path d="M13.0003 21.6666C15.2989 21.6666 17.5033 20.7535 19.1286 19.1282C20.7539 17.5029 21.667 15.2985 21.667 13C21.667 10.7014 20.7539 8.49702 19.1286 6.8717C17.5033 5.24639 15.2989 4.33329 13.0003 4.33329C10.7018 4.33329 8.49738 5.24639 6.87207 6.8717C5.24675 8.49702 4.33366 10.7014 4.33366 13C4.33366 15.2985 5.24675 17.5029 6.87207 19.1282C8.49738 20.7535 10.7018 21.6666 13.0003 21.6666ZM13.0003 23.8333C7.01708 23.8333 2.16699 18.9832 2.16699 13C2.16699 7.01671 7.01708 2.16663 13.0003 2.16663C18.9836 2.16663 23.8337 7.01671 23.8337 13C23.8337 18.9832 18.9836 23.8333 13.0003 23.8333ZM11.917 11.9166V18.4166H14.0837V11.9166H11.917ZM11.917 7.58329H14.0837V9.74996H11.917V7.58329Z" fill="black"/>
                      </svg>

                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>



        <div className="half-iphone py-5">
          <div className="max-w-[1380px] mx-auto lg:px-[24px] md:px-[24px] px-[16px] flex flex-wrap">
            <div className="lg:w-8/12 md:w-full w-full">
              <div className="half-i-des">
                <h2>
                  Why Do You <br />
                  Have To Choose <br />
                  And Use Edge?
                </h2>
                <div className="flex flex-wrap">
                  <div className="transaction-col sm:w-1/2 w-full">
                  <img src={globe} alt="Edge" className="img-fluid" />
                    <h3>Global Reach</h3>
                    <p>
                      Delivering solutions around the <br />
                      world quickly and securely
                    </p>
                  </div>
                  <div className="transaction-col sm:w-1/2 w-full">
                  <img src={thunder} alt="Edge" className="img-fluid" />
                    <h3>Fast and Easy Implementation</h3>
                    <p>
                      Edge prioritizes the satisfaction <br />
                      of our users. Try Edge now
          
                    </p>
                  </div>
                
                  <div className="transaction-col sm:w-1/2 w-full">
                  <img src={call} alt="Edge" className="img-fluid" />

                    <h3>24/7 Support</h3>
                    <p>
                      We are available 24/7 to help <br />
                      you. We are there for you
                    </p>
                  </div>
                  <div className="transaction-col sm:w-1/2 w-full">
                    {/* <FaHandHoldingHeart className="globe-h" /> */}
                    <img src={sat} alt="Edge" className="img-fluid " />

                    <h3>Your satisfaction is our priority</h3>
                    <p>
                      We always put the happiness of our clients first <br />
                      Edge Solutions
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="lg:w-4/12 md:w-full  w-full">
              <img src={homesec_3} alt="" />
            </div>
          </div>
        </div>
        </div>

        <div className="lap-sec">
          <h1>
            Stay on Edge On Our Web App <br /> or Mobile App
          </h1>
          <div className="lap-img container">
            <img src={lap} alt="Edge" className="img-fluid" />
          </div>
          <div className="peoples pb-10">
            <div className="max-w-[1380px] mx-auto flex flex-wrap md:space-y-[0px] space-y-[20px] ">
              <div className="md:w-4/12 w-full p-2">
                <div className="">
                  <h3>32k</h3>
                  <h2 className=" text-[22px]">More than 32k people use Edge</h2>
                  <p className="text-[17px] text-[#FFFFFF]/60 w-[90%] mx-auto">
                    More than 32k people have used our solutions, many
                    have benefited from Edge
                  </p>
                </div>
              </div>
              <div className="md:w-4/12 w-full p-2">
                <div className="peoples-des">
                  <h3>10k+</h3>
                  <h2 className=" text-[22px]">10k+ projects delivered</h2>
                  <p className="text-[17px] text-[#FFFFFF]/60 w-[90%] mx-auto">
                    More than 10k+ projects delivered successfully. You have to try
                  </p>
                </div>
              </div>
              <div className="md:w-4/12 w-full p-2">
                <div className="peoples-des">
                  <h3>40k+</h3>
                  <h2 className=" text-[22px]">40k+ clients helped</h2>
                  <p className="text-[17px] text-[#FFFFFF]/60 w-[90%] mx-auto">
                    40k+ clients have been helped by Edge's  solutions, we
                    are ready to help you
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="mobile-app md:pt-[150px] pt-[40px]  pb-[70px] px-[16px] ">
            <div className="max-w-[1380px] bg-[#262626]  md:pt-[80px] pt-[40px] lg:pb-[80px] md:pb-[40px] pb-[0px] relative rounded-[40px] mx-auto lg:px-[24px] md:px-[24px] px-[16px] flex flex-wrap lg:justify-between justify-normal items-center">
           
           <div className="md:w-1/2 w-full  flex md:justify-start justify-center lg:ml-[50px] md:ml-[10px] ml-[0px]">
              <div className=" w-fit flex-col justify-center flex ">
                <p>
                  Stay on Edge with <br /> our Digital Solutions
                </p>
                <div className="flex items-center lg:gap-[24px] md:gap-[14px] gap-[8px]">
                  <button className="bg-white flex items-center space-x-2 md:px-6 px-2 py-2 rounded-[8px]">
                    {/* <FaGooglePlay className="" size={24} /> */}
                    <svg xmlns="http://www.w3.org/2000/svg" className="md:w-[20px] sm:w-[20px] w-[18px] md:h-[30px] sm:h-[20px] h-[18px]"  viewBox="0 0 29 32" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.3484 15.991L0.275804 0.947754C0.102691 1.29692 0 1.7253 0 2.24464V29.7433C0 30.2685 0.105624 30.7057 0.284606 31.0548L15.3484 15.991Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.320312 0.852236C0.326337 0.837174 0.335375 0.825121 0.344412 0.810059C0.335375 0.825121 0.32935 0.840187 0.320312 0.852236Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.2191 15.1196L20.8608 10.4778L3.16219 0.422515C2.66045 0.134971 2.18806 0 1.76554 0C1.55135 0 1.35477 0.0381394 1.17285 0.105624L16.2191 15.1196Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M27.4082 14.198L21.983 11.1143L17.1006 15.9966L21.983 20.8673L27.4082 17.7835C29.1452 16.8006 29.1452 15.1839 27.4082 14.198Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.2317 16.8711L1.21777 31.8909C1.75472 32.0728 2.42664 31.9848 3.1631 31.5681L20.8735 21.5011L16.2317 16.8711Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.305664 31.1021C0.376274 31.2315 0.455712 31.3492 0.546916 31.4492C0.455712 31.3433 0.37039 31.2315 0.305664 31.1021Z" fill="black"/>
                      </svg>
                    <h2 className="text-[#000000] md:text-[16px] text-[12px] font-bold uppercase mb-0 bl-0 whitespace-nowrap">Coming Soon</h2>
                  </button>

                  <button className="bg-white flex items-center space-x-2 md:px-6 px-2 py-2 rounded-[8px]">
                    {/* <FaApple className="" size={24} /> */}
                    <svg xmlns="http://www.w3.org/2000/svg" className="md:w-[20px] sm:w-[20px] w-[18px] md:h-[30px] sm:h-[20px] h-[18px]" viewBox="0 0 29 35" fill="none">
                      <path d="M23.4416 18.3478C23.4776 15.661 24.8856 13.1789 27.1737 11.7709C25.7225 9.69831 23.3806 8.43034 20.8518 8.35132C18.1902 8.07115 15.6148 9.94256 14.257 9.94256C12.8741 9.94256 10.7872 8.37646 8.54217 8.42316C5.58599 8.52014 2.89561 10.1617 1.45523 12.7443C-1.60872 18.0496 0.675771 25.8442 3.61041 30.133C5.07952 32.2343 6.79648 34.5763 9.04146 34.4936C11.2397 34.4038 12.0587 33.0928 14.7132 33.0928C17.3389 33.0928 18.1112 34.4936 20.4028 34.4398C22.7592 34.4038 24.2462 32.3313 25.6615 30.212C26.7175 28.7142 27.5293 27.0619 28.0681 25.3126C25.2664 24.1308 23.4452 21.3866 23.4416 18.3478ZM19.1169 5.53163C20.4028 3.98708 21.035 2.00432 20.8842 0C18.9194 0.204742 17.1054 1.14584 15.8015 2.62932C14.5156 4.09484 13.8619 6.00936 13.9912 7.95261C15.9775 7.97416 17.8669 7.07977 19.1169 5.53163Z" fill="#010202"/>
                    </svg>
                    <h2 className="text-[#000000] md:text-[16px] text-[12px] font-bold uppercase mb-0 bl-0 whitespace-nowrap">Coming Soon</h2>
                  </button>
                </div>
                </div>
                </div>

                <div className=" md:w-1/2 w-full flex justify-center lg:justify-end md:absolute relative bottom-0 lg:right-[100px] 
                md:-right-[35px] ">
                <img src={appstore} alt="Edge" className=" w-[70%]" />
                </div>
               
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Homepage;
